import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core';
import styles from './styles';

export default withStyles(styles)(LinearProgress);
